const actions = {

    RANKING_DATA_DATA_BEGIN : 'RANKING_DATA_DATA_BEGIN',
    RANKING_DATA_DATA_SUCCESS: 'RANKING_DATA_DATA_SUCCESS',
    RANKING_DATA_DATA_ERR : 'RANKING_DATA_DATA_ERR',
    
 
    getStoreRankingDataBegin: () => {
        return {
            type: actions.RANKING_DATA_DATA_BEGIN,
        };
    },

    getStoreRankingDataSuccess: (data) => {
        return {
            type: actions.RANKING_DATA_DATA_SUCCESS,
            data,
        };
    },

    getStoreRankingDataErr: (err) => {
        return {
            type: actions.RANKING_DATA_DATA_ERR,
            err,
        };
    },

};

export default actions;
